/**
 * WordCountedTextarea — textarea with a word counter that goes red
 * when the soft limit is exceeded.
 *
 * Used for TenantProfile.description (100-word soft cap). Soft because
 * the backend schema doesn't hard-fail on length; the validator emits a
 * warning. But long descriptions inflate prompts so we surface the
 * limit in the UI.
 *
 * Phase 44.4.
 */

import { useMemo } from "react";

function countWords(s) {
  if (!s) return 0;
  return s.trim().split(/\s+/).filter(Boolean).length;
}

export default function WordCountedTextarea({
  label,
  value = "",
  onChange,
  softLimit = 100,
  rows = 5,
  placeholder = "",
  helpText,
}) {
  const words = useMemo(() => countWords(value), [value]);
  const over = words > softLimit;

  return (
    <div className="word-textarea">
      {label && <label className="word-textarea__label">{label}</label>}
      {helpText && <p className="word-textarea__help">{helpText}</p>}
      <textarea
        className="word-textarea__field"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={rows}
        placeholder={placeholder}
      />
      <div className={`word-textarea__counter ${over ? "word-textarea__counter--over" : ""}`}>
        {words} / {softLimit} words
        {over && " — consider trimming"}
      </div>
    </div>
  );
}
